/**Import react section */
import React from 'react'
import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
/**Import MaterialUi section */
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, ListItem, List } from '@material-ui/core'
import LinkMaterial from '@material-ui/core/Link'
/**Import components section */

/**Import store section */

const DialogProspect = (props) => {
	/**props section */
	const { handleOpen, open, prospect } = props

	return (
		<Dialog
			open={open}
			onClose={<Button onClick={handleOpen}>Cerrar</Button>}
			aria-labelledby='alert-dialog-title'
			aria-describedby='alert-dialog-description'
		>
			<DialogTitle id='alert-dialog-title'>
				<strong style={{ color: '#3b73af' }}>{'Mensaje que se enviara de alta proveedor'}</strong>
			</DialogTitle>
			<DialogContent dividens>
				<div>
					<strong style={{ color: '#3b73af' }}>ESTIMADO PROVEEDOR:</strong>
					<br />
					<br />
					Le damos la bienvenida a nuestro sistema, le informamos que su razón social quedó registrada bajo el{' '}
					<strong> No. De proveedor:</strong> {prospect.supplier_code}, <br />
					<strong> RAZON SOCIAL:</strong> {prospect.prospect_name}
					<br />
					<br />
					<div>Aquí la información para gestión de facturas.</div>
					<br />
					<div>Favor de coordinarse con su contacto sobre la entrada de sus facturas en almacén.</div>
					<br />
					<div>
						<strong style={{ color: '#3b73af' }}> UPINVOICES:</strong>
					</div>
					<div>
						1. Ingresar a la liga:
						<a href='https://www.upinvoices.com'>https://www.upinvoices.com</a>
						<br />
						2.Registro proveedor.
						<br />
						3.Registro de la empresa PTM o MPV
						<br />
						4. Para más detalles ver el manual adjunto (MANUAL UPINVOICES V.2)
					</div>
					<br />
					<br />
					<div>En este portal podrá realizar las siguientes tareas:</div>
					<br />
					<div>
						<strong style={{ color: '#3b73af' }}>
							○ Subir facturas para pago. <br />
							○ Consultar estatus de las facturas.
							<br />
							○ Subir notas de crédito
							<br />
							○ Generar ticket para aclaraciones
							<br />
							○ Generar un ticket en el apartado de soporte para fallas o errores
							<br />○ Subir complementos de pago.
						</strong>
						<br />
						<br />
						Carpeta de drive:{' '}
						<a
							style={{ textDecoration: 'none', color: '#3b73af' }}
							href='https://ammimx-my.sharepoint.com/:f:/g/personal/andrea_gonzalez_ptm_mx/IgAnzgRzu77xRrH30Kj0CuoVAXhZ0AxIWG_glVA9gfw7Lw4?e=p1K7Jm'
						>
							PORTAL UPINVOICES
						</a>
					</div>
					<br />
					<br />
					<table style={{ borderCollapse: 'collapse' }}>
						<tbody>
							<tr>
								<td style={{ border: 'none', padding: '8px' }}>Tel. 427 289 9291</td>
								<td style={{ border: 'none', padding: '8px' }}>Tel. 427 289 9291</td>
							</tr>
							<tr>
								<td
									style={{
										border: 'none',
										padding: '8px',
										color: 'blue',
										textDecoration: 'underline',
										fontWeight: 'bold',
										cursor: 'pointer',
									}}
								>
									<a
										style={{ textDecoration: 'none', color: '#3b73af' }}
										href='perla.alvarado@ptm.mx'
									>
										{' '}
										perla.alvarado@ptm.mx{' '}
									</a>
								</td>
								<td
									style={{
										border: 'none',
										padding: '8px',
										color: 'blue',
										textDecoration: 'underline',
										fontWeight: 'bold',
										cursor: 'pointer',
									}}
								>
									<a
										style={{ textDecoration: 'none', color: '#3b73af' }}
										href='andrea.gonzalez@ptm.mx'
									>
										andrea.gonzalez@ptm.mx
									</a>
								</td>
							</tr>
						</tbody>
					</table>
					<div>
						<strong style={{ color: '#3b73af' }}>SIP, (Sistema de Información de Proveedores)</strong>
					</div>
					<br />
					<div>
						1. Ingresar a la liga:
						<a href='https://sip.ptm.mx/v2.0/portal/'> https://sip.ptm.mx/v2.0/portal/ </a> <br />
						2. El usuario del administrador es:{' '}
						<strong style={{ color: '#DC3545' }}>número de proveedor-admin</strong> <br />
						3. Solicitar restauración de contraseña.
						<br />
						4. La contraseña llegará al correo electrónico del contacto de ventas.
						<br />
						5. Para más detalles ver el manual adjunto.
						<br />
					</div>
					<br />
					<div>En este portal podrá realizar las siguientes tareas:</div>
					<div>
						○ Consultar entradas de almacén para captura de factura. <br />
						○ Seguimiento a pagos. <br />
						○ Consulta de órdenes de compra. <br />
						○ Enviar cotizaciones. <br />○ Ordenes de entrega (requisito indispensable para entrega, ver
						manual anexo){' '}
						<strong style={{ color: '#DC3545' }}>
							(requisito indispensable para entrega, ver manual anexo)
						</strong>{' '}
						<br />
						○ Acciones Correctivas. <br />
						○ Seguimiento a Evaluación de Proveedores. <br />
					</div>
					<br />
					<br />
					<div>
						Le agradecemos registrase en ambos portales.
						<br />
						<br />
						Cualquier duda o comentario estamos a sus órdenes.
						<br />
						<br />
						Saludos!!!
						<br />
						<br />
					</div>
					<List component='div' disablePadding>
						<ListItem component='li'>
							<strong style={{ color: '#3b73af' }}>Documentos a Enviar</strong>
						</ListItem>
						{prospect.aditional_files.map((document) => {
							return (
								<React.Fragment key={document.name}>
									<ListItem key={document.name} component='li'>
										<LinkMaterial
											component={'a'}
											style={{ marginLeft: '3rem' }}
											target='_blank'
											href={`${process.env.REACT_APP_SIP_URL_ADMINISTRATION}/${document.relativePath}`}
										>
											{'  '}
											{document.name}
										</LinkMaterial>
									</ListItem>
								</React.Fragment>
							)
						})}
					</List>
				</div>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleOpen}>Cerrar</Button>
			</DialogActions>
		</Dialog>
	)
}

const styles = (theme) => ({
	avatar: {
		backgroundColor: theme.palette.primary.main,
	},

	containerInformation: {
		maxHeight: `calc(100vh - ${155}px)`,
		minHeight: `calc(100vh - ${155}px)`,
		overflowY: 'auto',
		padding: '10px',
	},
	containerBtn: {
		display: 'flex',
		justifyContent: 'center',
	},
	inputProps: {
		height: 6,
	},
	titles: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		marginLeft: '7px',
		marginBottom: 5,
	},
	margin: {
		margin: '15px 15px 15px 15px',
	},
})

export default withRouter(withStyles(styles, { withTheme: true })(DialogProspect))
